module.exports = __webpack_public_path__ + "static/185056863.acce366f.jpg";